/**
 * Extract domain from URL
 * @param {string} url - The URL to extract domain from
 * @returns {string} - The domain or empty string if invalid
 */
export const extractDomain = (url) => {
  if (!url) return '';

  try {
    // Add protocol if missing
    const urlWithProtocol = url.startsWith('http') ? url : `https://${url}`;
    const urlObj = new URL(urlWithProtocol);
    return urlObj.hostname.replace('www.', '');
  } catch (error) {
    console.warn('Invalid URL for domain extraction:', url);
    return '';
  }
};

/**
 * Get favicon URL using Google's favicon service
 * @param {string} url - The website URL
 * @param {number} size - Size of the favicon (default: 32)
 * @returns {string} - The favicon URL
 */
export const getFaviconUrl = (url, size = 32) => {
  const domain = extractDomain(url);
  if (!domain) return '';

  return `https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`;
};

/**
 * Get alternative favicon URL using DuckDuckGo service (fallback)
 * @param {string} url - The website URL
 * @returns {string} - The favicon URL
 */
export const getFaviconUrlFallback = (url) => {
  const domain = extractDomain(url);
  if (!domain) return '';

  return `https://icons.duckduckgo.com/ip3/${domain}.ico`;
};

/**
 * Get website name from URL for display purposes
 * @param {string} url - The website URL
 * @returns {string} - A formatted website name
 */
export const getWebsiteName = (url) => {
  const domain = extractDomain(url);
  if (!domain) return 'External';

  // Remove common TLDs and format nicely
  const name = domain
    .replace(/\.(com|net|org|io|co|gov|edu)$/, '')
    .split('.')
    .pop();

  return name.charAt(0).toUpperCase() + name.slice(1);
};
